<template>
	<div class="service-container">
		<div class="head">SERVICE</div>
		<ul class="contact-mode">
			<li><span class="tl">Phone：</span><span class="text">{{contact.mobile}}</span></li>
			<li><span class="tl">Email：</span><span class="text">{{contact.email}}</span></li>
			<li><span class="tl">QQ：</span><span class="text">{{contact.qq}}</span></li>
			<li><span class="tl">WeChat：</span><span class="text">{{contact.wechat}}</span></li>
		</ul>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'

	export default {
		data() {
			return {

			}
		},
		computed: {
			...mapState({

				contact: state => state.contact
				
			}),
		},
		mounted() {

		},
		methods: {
			
		}
	}
</script>

<style lang="less">
	.service-container {
		.contact-mode {
			li {
				margin-bottom: 9px;
				font-size: 16px;
				line-height: 3;
				color: #666;
				.tl {
					width: 110px;
					text-align: right;
					color: #333;
					display: inline-block;
				}
			}
		}
	}

   @media screen and (max-width:768px) {
        .service-container {
        	
	        .contact-mode {
				padding-left:0px;
				li {
					font-size: 12px;
					.tl {
						width: 80px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Service.vue